<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <!-- <form @submit.prevent="setFilter"> -->
        <h6 class="heading-small text-muted mb-4">Search</h6>
        <div class="row mb-3">
          <div class="col">
            <form @submit.prevent="setFilter">
              <a-input placeholder="Search by" v-model="table.filters.name">
                <a-select
                  slot="addonAfter"
                  default-value="name"
                  style="width: 110px"
                >
                  <a-select-option value="name"> name </a-select-option>
                </a-select>
              </a-input>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <form role="form" @submit.prevent>
              <div>
                <div>
                  <h6 class="heading-small text-muted mb-4">Filter by Code</h6>
                </div>
                <div class="row mb-3">
                  <div class="col">
                    <a-select
                      v-model="table.filters.code"
                      show-search
                      mode="multiple"
                      optionFilterProp="children"
                    >
                      <a-select-option
                        v-for="opt in options.codes"
                        v-bind:value="opt"
                        v-bind:key="opt"
                      >
                        {{ opt }}
                      </a-select-option>
                    </a-select>
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <h6 class="heading-small text-muted mb-4">Filter by Area</h6>
                </div>
                <div class="row mb-3">
                  <div class="col">
                    <a-select
                      v-model="table.filters.area"
                      show-search
                      mode="multiple"
                      optionFilterProp="children"
                    >
                      <a-select-option
                        v-for="opt in options.areas"
                        v-bind:value="opt"
                        v-bind:key="opt"
                      >
                        {{ opt }}
                      </a-select-option>
                    </a-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <base-button
                    type="primary btn-block"
                    class="my-4"
                    @click.prevent="applyFilter"
                  >
                    <div>Apply Filter</div>
                  </base-button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- </form> -->
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
          :sortOrder="table.sortOrder"
        >
          <template #headerButtons>
            <base-button
              id="new"
              class="float-right ml-1"
              type="primary"
              size="sm"
              v-if="selectedActions.includes('Add')"
              @click="openDrawer()"
              >+ Create Site</base-button
            >
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <SiteForm
                :viewMode="viewMode"
                :siteData="siteData"
                :systemModules="systemModules"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{ tableProps }">
            <button
              id="view"
              v-if="selectedActions.includes('View')"
              class="btn btn-success btn-sm"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
            </button>

            <button
              id="edit"
              v-if="selectedActions.includes('Edit')"
              class="btn btn-warning btn-sm"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              Edit
            </button>
            <a-popconfirm
              title="You are about to delete this record?"
              @confirm="deleteRow(tableProps.rowData)"
              okText="Delete"
              cancelText="Cancel"
            >
              <a class="btn btn-danger btn-sm text-white">Delete</a>
            </a-popconfirm>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import SiteForm from './SiteForm.vue';
import HTTPRequest from '@/controllers/httpRequest';
import { mapGetters } from 'vuex';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    SiteForm
  },
  data() {
    return {
      gradientType: 'gradient-blue',
      // selectedActions: [],
      siteData: null,
      systemModules: null,
      drawer: {
        visible: false,
        width: 800,
        placement: 'right'
      },
      viewMode: false,
      search: null,
      searchType: 'name',
      table: {
        title: 'Sites',
        apiUrl: '/api/v1/sites',
        fields: [
          'actions',
          { name: 'code', title: 'Code' },
          { name: 'name', title: 'Name' },
          { name: 'area', title: 'Area' },
          { name: 'address', title: 'Address' }
        ],
        sortOrder: [
          {
            field: 'id',
            direction: 'asc'
          }
        ],
        filters: {
          name: null,
          code: [],
          area: []
        }
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      },
      options: {
        codes: [],
        areas: []
      }
    };
  },
  methods: {
    searchTypeOnChange() {
      this.table.filters.hasFilter = false;

      if (this.search != null && this.search != '') {
        this.table.filters['name'] = null;
        this.table.filters['code'] = [];
        this.table.filters['area'] = [];
        this.table.filters[this.searchType] = this.search;
      }
    },
    async openDrawer(rowData = null) {
      this.siteData = rowData;

      this.viewMode = event.target.id == 'view' ? true : false;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.siteData = null;
    },

    applyFilter() {
      if (
        this.table.filters['name'] == null &&
        this.table.filters['code'] == [] &&
        this.table.filters['area'] == []
      ) {
        this.table.filters.hasFilter = false;
      } else {
        this.table.filters.hasFilter = true;
      }
      this.setFilter();
    },
    setFilter() {
      this.$root.$emit('refreshTable');
    },

    async getCodeFilters() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/sites/filters?filter=code'
      );

      let data = [];
      for (let x in response) {
        data.push(response[x].code);
      }
      this.options.codes = data;
    },
    async getAreaFilters() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/sites/filters?filter=area'
      );
      let data = [];
      for (let x in response) {
        data.push(response[x].area);
      }
      this.options.areas = data;
    },

    async deleteRow(rowData) {
      const siteId = rowData.id;
      const response = await HTTPRequest.deleteRequest(
        `/api/v1/sites/${siteId}`
      );

      if (response.message == 'Success') {
        this.$notification.success({
          message: 'Success'
        });
        this.$root.$emit('refreshTable');
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },

  mounted() {
    // this.selectedActions = this.$store.getters.getModuleSelectedActions;
  },

  created() {
    this.$store.dispatch('setCurrentModule', 'Site');
    this.getCodeFilters();
    this.getAreaFilters();
  },
  watch: {
    search(val) {
      if (val == '') {
        this.search = null;
      } else {
        this.table.filters.hasFilter = true;
      }

      this.table.filters[this.searchType] = val;
    }
  }
};
</script>

<style scoped></style>
